import formatDate from '@/apis/utils/formatDate';

export default function parseSaleComment({
  id,
  is_deleted,
  is_enabled,
  IsCompany,
  created_at,
  updated_at,
  sale_id,
  customer_user_id,
  user_id,
  body,
  user_display_name,
  user_avatar_url,
  Company,
}) {
  const nextCreatedAt = formatDate(created_at);
  const nextUpdatedAt = formatDate(updated_at);

  return Object.assign(
    {},
    {
      id,
      is_deleted,
      is_enabled,
      created_at: nextCreatedAt,
      updated_at: nextUpdatedAt,
      sale_id,
      customer_user_id,
      user_id,
      body,
      userDisplayName: user_display_name,
      userIsCompany: IsCompany,
      userCompany: Company,
      icon: user_avatar_url,
    }
  );
}
